import { render, staticRenderFns } from "./ChargeComp.vue?vue&type=template&id=51896766&scoped=true"
import script from "./ChargeComp.vue?vue&type=script&lang=js"
export * from "./ChargeComp.vue?vue&type=script&lang=js"
import style0 from "./ChargeComp.vue?vue&type=style&index=0&id=51896766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51896766",
  null
  
)

export default component.exports